import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Bid from "../views/Bid.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/new-bid",
    name: "Bid",
    component: Bid,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/new-bid",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
